import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { UPDATE_REQUEST_TYPE } from "../../../configs/constants";
import { getAppHeader } from "../../../configs/config";
import { InputStateToken } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { isMobile } from "../../../configs/utils";
let counter = 0;
export const verifyNewNumber = async (action, _datastore, { network, setDatastore }) => {
    let requestValue = action?.payload?.requestValue;
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user?.linkedApplications[0].accountId;
    await setDatastore(action.routeId, "updateEmailScreen", {
        errorModal: false,
        defaultErrorModal: false,
        otpModal: false,
        modalHeight: 0,
        otpErrorModal: false,
        errorMessage: '',
        counter: counter++,
    });
    const response = await network.post(`${api.updateNewUserDetails}`, {
        borrowerAccountId,
        requestType: UPDATE_REQUEST_TYPE.EMAIL,
        requestValue,
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(action.routeId, 'updateEmailScreen', {
            errorModal: false,
            defaultErrorModal: false,
            otpModal: true,
            counter: counter++,
        });
    }
    else {
        if (response.response.data.voltErrorCode === "EMAIL_ALREADY_EXIST") {
            await setDatastore(action.routeId, "updateEmailScreen", {
                errorModal: true,
                defaultErrorModal: false,
                otpModal: false,
                modalHeight: isMobile() ? 264 : 240,
                errorMessage: response?.response?.data?.message,
                counter: counter++,
            });
        }
        else if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "updateEmailScreen", {
                errorModal: false,
                defaultErrorModal: false,
                otpModal: false,
                modalHeight: isMobile() ? 264 : 240,
                otpErrorModal: true,
                errorMessage: response?.response?.data?.message,
                counter: counter++,
            });
        }
        else {
            await setDatastore(action.routeId, "updateEmailScreen", {
                errorModal: false,
                defaultErrorModal: true,
                otpModal: false,
                modalHeight: 210,
                errorMessage: "Something went wrong",
                counter: counter++,
            });
        }
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const closeModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, "updateEmailScreen", {
        errorModal: false,
        defaultErrorModal: false,
        otpModal: false,
        modalHeight: 0,
        errorMessage: '',
        otpErrorModal: false,
        counter: counter++,
    });
};
export const verifyOtp = async (action, _datastore, { network, setDatastore, navigate }) => {
    const otp = action?.payload?.otp;
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user?.linkedApplications[0].accountId;
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    await setDatastore(action.routeId, "updateEmailScreen", {
        state: InputStateToken.DEFAULT,
        counter: counter++,
    });
    const response = await network.post(`${api.verifyOtpNewuserDetails}`, {
        otp: otp,
        borrowerAccountId: borrowerAccountId
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await navigate(ROUTE.UPDATE_DETAILS_SCREEN, { result: response?.data });
    }
    else {
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "updateEmailScreen", {
                state: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                counter: counter++,
            });
        }
        else {
            await setDatastore(action.routeId, "updateEmailScreen", {
                state: InputStateToken.ERROR,
                caption: { error: response.response.data.message },
                counter: counter++,
            });
        }
    }
};
export const resendOtp = async (action, _datastore, { network, setDatastore }) => {
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user?.linkedApplications[0].accountId;
    const requestType = UPDATE_REQUEST_TYPE.PHONE_NUMBER;
    const requestValue = action?.payload?.requestValue;
    const response = await network.post(`${api.updateNewUserDetails}`, {
        borrowerAccountId,
        requestType,
        requestValue,
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(action.routeId, "updateEmailScreen", {
            state: InputStateToken.SUCCESS,
            counter: counter++,
        });
    }
    else {
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "updateEmailScreen", {
                state: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                counter: counter++,
            });
        }
        else {
            await setDatastore(action.routeId, "updateEmailScreen", {
                state: InputStateToken.ERROR,
                caption: { error: response.response.data.message },
                counter: counter++,
            });
        }
    }
};
export const handleCloseOtpModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, "updateEmailScreen", {
        state: InputStateToken.DEFAULT,
        counter: counter++,
    });
};
